export const SCHEMA_VERSION = 1;

export const DDL = `
CREATE TABLE IF NOT EXISTS files (
  path TEXT PRIMARY KEY,
  mtime_ms INTEGER NOT NULL,
  size INTEGER NOT NULL,
  byte_offset INTEGER NOT NULL DEFAULT 0,
  kind TEXT NOT NULL,
  session_id TEXT,
  agent_id TEXT,
  parent_session_id TEXT,
  last_scanned_at INTEGER NOT NULL
);

CREATE TABLE IF NOT EXISTS turns (
  uuid TEXT PRIMARY KEY,
  message_id TEXT,
  request_id TEXT,
  session_id TEXT NOT NULL,
  agent_id TEXT,
  parent_session_id TEXT,
  is_sidechain INTEGER NOT NULL DEFAULT 0,
  ts INTEGER NOT NULL DEFAULT 0,
  model TEXT NOT NULL,
  input_tokens INTEGER NOT NULL DEFAULT 0,
  output_tokens INTEGER NOT NULL DEFAULT 0,
  cache_creation_tokens INTEGER NOT NULL DEFAULT 0,
  cache_read_tokens INTEGER NOT NULL DEFAULT 0,
  cache_5m_tokens INTEGER NOT NULL DEFAULT 0,
  cache_1h_tokens INTEGER NOT NULL DEFAULT 0,
  tools TEXT NOT NULL DEFAULT '[]',
  num_tool_uses INTEGER NOT NULL DEFAULT 0,
  thinking_chars INTEGER NOT NULL DEFAULT 0,
  text_chars INTEGER NOT NULL DEFAULT 0,
  stop_reason TEXT,
  cwd TEXT,
  slug TEXT,
  git_branch TEXT,
  version TEXT,
  speed TEXT,
  inference_geo TEXT,
  file_path TEXT NOT NULL
);
CREATE INDEX IF NOT EXISTS idx_turns_session ON turns(session_id);
CREATE INDEX IF NOT EXISTS idx_turns_ts ON turns(ts);
CREATE INDEX IF NOT EXISTS idx_turns_file ON turns(file_path);
CREATE INDEX IF NOT EXISTS idx_turns_msg ON turns(message_id);

CREATE TABLE IF NOT EXISTS events (
  id INTEGER PRIMARY KEY AUTOINCREMENT,
  session_id TEXT NOT NULL,
  ts INTEGER,
  kind TEXT NOT NULL,
  data TEXT NOT NULL DEFAULT '{}',
  file_path TEXT NOT NULL
);
CREATE INDEX IF NOT EXISTS idx_events_session ON events(session_id, ts);
CREATE INDEX IF NOT EXISTS idx_events_file ON events(file_path);

CREATE TABLE IF NOT EXISTS meta (
  key TEXT PRIMARY KEY,
  value TEXT NOT NULL
);
`;
